// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/chats/chat.proto (package protos.entities.app.chats, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { WorkFunction } from "../../../general/work_function_pb";
import { file_general_work_function } from "../../../general/work_function_pb";
import type { ProjectUnionType } from "../../../projects/project_union_type_pb";
import { file_projects_project_union_type } from "../../../projects/project_union_type_pb";
import type { ChatType } from "./chat_type_pb";
import { file_entities_app_chats_chat_type } from "./chat_type_pb";
import type { ChatMember } from "./chat_member_pb";
import { file_entities_app_chats_chat_member } from "./chat_member_pb";
import type { ChatRequestStatus } from "./chat_request_status_pb";
import { file_entities_app_chats_chat_request_status } from "./chat_request_status_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file entities/app/chats/chat.proto.
 */
export const file_entities_app_chats_chat: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_general_work_function, file_projects_project_union_type, file_entities_app_chats_chat_type, file_entities_app_chats_chat_member, file_entities_app_chats_chat_request_status]);

/**
 * @generated from message protos.entities.app.chats.Chat
 */
export type Chat = Message<"protos.entities.app.chats.Chat"> & {
  /**
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * @generated from field: protos.entities.app.chats.ChatType chat_type = 2;
   */
  chatType: ChatType;

  /**
   * @generated from field: repeated protos.entities.app.chats.ChatMember members_preview = 3;
   */
  membersPreview: ChatMember[];

  /**
   * @generated from field: int32 member_count = 4;
   */
  memberCount: number;

  /**
   * @generated from field: protos.entities.app.chats.Chat.LastMessage last_message = 5;
   */
  lastMessage?: Chat_LastMessage | undefined;

  /**
   * @generated from oneof protos.entities.app.chats.Chat.data
   */
  data: {
    /**
     * @generated from field: protos.entities.app.chats.Chat.DirectData direct_data = 6;
     */
    value: Chat_DirectData;
    case: "directData";
  } | {
    /**
     * @generated from field: protos.entities.app.chats.Chat.GroupData group_data = 7;
     */
    value: Chat_GroupData;
    case: "groupData";
  } | {
    /**
     * @generated from field: protos.entities.app.chats.Chat.JobData job_data = 8;
     */
    value: Chat_JobData;
    case: "jobData";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: bool is_read = 10;
   */
  isRead: boolean;

  /**
   * @generated from field: bool is_muted = 11;
   */
  isMuted: boolean;

  /**
   * @generated from field: bool is_hidden = 12;
   */
  isHidden: boolean;

  /**
   * @generated from field: protos.entities.app.chats.Chat.ChatRequest request = 13;
   */
  request?: Chat_ChatRequest | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp joined_at = 14;
   */
  joinedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 16;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp sort_timestamp = 17;
   */
  sortTimestamp?: Timestamp | undefined;

  /**
   * @generated from field: repeated protos.entities.app.chats.Chat.BlockedMember blocked_members = 18;
   */
  blockedMembers: Chat_BlockedMember[];
};

/**
 * Describes the message protos.entities.app.chats.Chat.
 * Use `create(ChatSchema)` to create a new message.
 */
export const ChatSchema: GenMessage<Chat> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0);

/**
 * @generated from message protos.entities.app.chats.Chat.LastMessage
 */
export type Chat_LastMessage = Message<"protos.entities.app.chats.Chat.LastMessage"> & {
  /**
   * @generated from field: protos.entities.app.chats.Chat.LastMessage.CreatedBy created_by = 1;
   */
  createdBy?: Chat_LastMessage_CreatedBy | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from oneof protos.entities.app.chats.Chat.LastMessage.data
   */
  data: {
    /**
     * @generated from field: protos.entities.app.chats.Chat.LastMessage.MessageTextData text_data = 3;
     */
    value: Chat_LastMessage_MessageTextData;
    case: "textData";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.entities.app.chats.Chat.LastMessage.
 * Use `create(Chat_LastMessageSchema)` to create a new message.
 */
export const Chat_LastMessageSchema: GenMessage<Chat_LastMessage> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 0);

/**
 * @generated from message protos.entities.app.chats.Chat.LastMessage.MessageTextData
 */
export type Chat_LastMessage_MessageTextData = Message<"protos.entities.app.chats.Chat.LastMessage.MessageTextData"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message protos.entities.app.chats.Chat.LastMessage.MessageTextData.
 * Use `create(Chat_LastMessage_MessageTextDataSchema)` to create a new message.
 */
export const Chat_LastMessage_MessageTextDataSchema: GenMessage<Chat_LastMessage_MessageTextData> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 0, 0);

/**
 * @generated from message protos.entities.app.chats.Chat.LastMessage.CreatedBy
 */
export type Chat_LastMessage_CreatedBy = Message<"protos.entities.app.chats.Chat.LastMessage.CreatedBy"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.entities.app.chats.Chat.LastMessage.CreatedBy.
 * Use `create(Chat_LastMessage_CreatedBySchema)` to create a new message.
 */
export const Chat_LastMessage_CreatedBySchema: GenMessage<Chat_LastMessage_CreatedBy> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 0, 1);

/**
 * @generated from message protos.entities.app.chats.Chat.DirectData
 */
export type Chat_DirectData = Message<"protos.entities.app.chats.Chat.DirectData"> & {
};

/**
 * Describes the message protos.entities.app.chats.Chat.DirectData.
 * Use `create(Chat_DirectDataSchema)` to create a new message.
 */
export const Chat_DirectDataSchema: GenMessage<Chat_DirectData> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 1);

/**
 * @generated from message protos.entities.app.chats.Chat.GroupData
 */
export type Chat_GroupData = Message<"protos.entities.app.chats.Chat.GroupData"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: protos.entities.app.chats.Chat.GroupData.CreatedBy created_by = 2;
   */
  createdBy?: Chat_GroupData_CreatedBy | undefined;

  /**
   * @generated from field: repeated protos.entities.app.chats.Chat.GroupData.Admin admins = 3;
   */
  admins: Chat_GroupData_Admin[];
};

/**
 * Describes the message protos.entities.app.chats.Chat.GroupData.
 * Use `create(Chat_GroupDataSchema)` to create a new message.
 */
export const Chat_GroupDataSchema: GenMessage<Chat_GroupData> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 2);

/**
 * @generated from message protos.entities.app.chats.Chat.GroupData.CreatedBy
 */
export type Chat_GroupData_CreatedBy = Message<"protos.entities.app.chats.Chat.GroupData.CreatedBy"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.entities.app.chats.Chat.GroupData.CreatedBy.
 * Use `create(Chat_GroupData_CreatedBySchema)` to create a new message.
 */
export const Chat_GroupData_CreatedBySchema: GenMessage<Chat_GroupData_CreatedBy> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 2, 0);

/**
 * @generated from message protos.entities.app.chats.Chat.GroupData.Admin
 */
export type Chat_GroupData_Admin = Message<"protos.entities.app.chats.Chat.GroupData.Admin"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message protos.entities.app.chats.Chat.GroupData.Admin.
 * Use `create(Chat_GroupData_AdminSchema)` to create a new message.
 */
export const Chat_GroupData_AdminSchema: GenMessage<Chat_GroupData_Admin> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 2, 1);

/**
 * @generated from message protos.entities.app.chats.Chat.JobData
 */
export type Chat_JobData = Message<"protos.entities.app.chats.Chat.JobData"> & {
  /**
   * @generated from field: protos.entities.app.chats.Chat.JobData.Job job = 1;
   */
  job?: Chat_JobData_Job | undefined;

  /**
   * @generated from field: protos.entities.app.chats.Chat.JobData.Applicant applicant = 2;
   */
  applicant?: Chat_JobData_Applicant | undefined;

  /**
   * @generated from field: protos.entities.app.chats.Chat.JobData.CreatedBy created_by = 3;
   */
  createdBy?: Chat_JobData_CreatedBy | undefined;
};

/**
 * Describes the message protos.entities.app.chats.Chat.JobData.
 * Use `create(Chat_JobDataSchema)` to create a new message.
 */
export const Chat_JobDataSchema: GenMessage<Chat_JobData> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 3);

/**
 * @generated from message protos.entities.app.chats.Chat.JobData.Job
 */
export type Chat_JobData_Job = Message<"protos.entities.app.chats.Chat.JobData.Job"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;

  /**
   * @generated from field: string project_name = 2;
   */
  projectName: string;

  /**
   * @generated from field: protos.general.WorkFunction work_function = 3;
   */
  workFunction: WorkFunction;

  /**
   * @generated from field: string cover_url = 4;
   */
  coverUrl: string;

  /**
   * @generated from field: protos.projects.ProjectUnionType union_type = 5;
   */
  unionType: ProjectUnionType;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.entities.app.chats.Chat.JobData.Job.
 * Use `create(Chat_JobData_JobSchema)` to create a new message.
 */
export const Chat_JobData_JobSchema: GenMessage<Chat_JobData_Job> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 3, 0);

/**
 * @generated from message protos.entities.app.chats.Chat.JobData.Applicant
 */
export type Chat_JobData_Applicant = Message<"protos.entities.app.chats.Chat.JobData.Applicant"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message protos.entities.app.chats.Chat.JobData.Applicant.
 * Use `create(Chat_JobData_ApplicantSchema)` to create a new message.
 */
export const Chat_JobData_ApplicantSchema: GenMessage<Chat_JobData_Applicant> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 3, 1);

/**
 * @generated from message protos.entities.app.chats.Chat.JobData.CreatedBy
 */
export type Chat_JobData_CreatedBy = Message<"protos.entities.app.chats.Chat.JobData.CreatedBy"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message protos.entities.app.chats.Chat.JobData.CreatedBy.
 * Use `create(Chat_JobData_CreatedBySchema)` to create a new message.
 */
export const Chat_JobData_CreatedBySchema: GenMessage<Chat_JobData_CreatedBy> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 3, 2);

/**
 * @generated from message protos.entities.app.chats.Chat.ChatRequest
 */
export type Chat_ChatRequest = Message<"protos.entities.app.chats.Chat.ChatRequest"> & {
  /**
   * @generated from field: protos.entities.app.chats.Chat.ChatRequest.RequestedBy requested_by = 1;
   */
  requestedBy?: Chat_ChatRequest_RequestedBy | undefined;

  /**
   * @generated from field: protos.entities.app.chats.ChatRequestStatus status = 2;
   */
  status: ChatRequestStatus;
};

/**
 * Describes the message protos.entities.app.chats.Chat.ChatRequest.
 * Use `create(Chat_ChatRequestSchema)` to create a new message.
 */
export const Chat_ChatRequestSchema: GenMessage<Chat_ChatRequest> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 4);

/**
 * @generated from message protos.entities.app.chats.Chat.ChatRequest.RequestedBy
 */
export type Chat_ChatRequest_RequestedBy = Message<"protos.entities.app.chats.Chat.ChatRequest.RequestedBy"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message protos.entities.app.chats.Chat.ChatRequest.RequestedBy.
 * Use `create(Chat_ChatRequest_RequestedBySchema)` to create a new message.
 */
export const Chat_ChatRequest_RequestedBySchema: GenMessage<Chat_ChatRequest_RequestedBy> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 4, 0);

/**
 * @generated from message protos.entities.app.chats.Chat.BlockedMember
 */
export type Chat_BlockedMember = Message<"protos.entities.app.chats.Chat.BlockedMember"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message protos.entities.app.chats.Chat.BlockedMember.
 * Use `create(Chat_BlockedMemberSchema)` to create a new message.
 */
export const Chat_BlockedMemberSchema: GenMessage<Chat_BlockedMember> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat, 0, 5);

